import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Box } from "@mui/material";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Banner = () => {
  const imageFiles = [1, 2, 3, 4, 5, 6];

  return (
    <Box sx={{ width: "100%", my: 4 }}>
      <Box
        sx={{
          width: {
            xs: "95%",
            sm: "90%",
            md: "85%",
            lg: "85%",
          },
          mx: "auto",
        }}
      >
        <Carousel
          autoPlay
          autoPlaySpeed={4000}
          infinite
          arrows
          showDots
          responsive={responsive}
        >
          {imageFiles.map((num, i) => (
            <Box key={i}>
              <img
                src={`/images/banner/${num}.png`}
                alt={`Banner ${num}`}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "12px",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
};

export default Banner;
